//components
import ContentItemPublishedStatus from  '@/components/elements/lists/ContentItemPublishedStatus';
import ListContentTile from  '@/components/elements/lists/ListContentTitle';
import FoundInTile from  '@/components/elements/lists/FoundInTile';
import FoundInPublishedStatus from  '@/components/elements/lists/FoundInPublishedStatus';
import { BasicRadioButton, IconButton, IconLibrary } from 'thrive-components';

//helpers
import { foundInScheduledStatus, scheduledStatus } from './List';

//interfaces
import { ISearchContentItem } from  '@/interfaces/content';

export interface IContentItem {
    id: number;
    title: string;
    type: string;
    featuredImageUrl: string | null;
    groupCount: number;
    groupUserCount: number;
    status: 'draft' | 'published' | 'archived';
    permission: 'view' | 'edit' | 'admin';
    parentIdAndTitles: {
        id: number;
        title: string;
    }[];
    everyoneHasAccess: boolean;
    scheduledPublishDate: string | null;
    scheduledArchiveDate: string | null;
}

export function getBasicContentRow(appGuid: string, content: IContentItem, onOpenListClick: (listId: number, listTitle: string)=>void, setSelectedContentId: (id: number)=>void, selectedContentId?: number) {
    if (content.type === "list") {        
        return {
            content: [
                <ListContentTile 
                    key={`${content.id}-content-title`}
                    listId={content?.parentIdAndTitles[0]?.id.toString()}
                    appGuid={appGuid}
                    item={content}
                    status={<ContentItemPublishedStatus item={content}/>}
                    archiveStatus={scheduledStatus(content.scheduledPublishDate, content.scheduledArchiveDate)}
                    isNotALink
                />,
                <IconButton 
                    ariaLabel={'Open list content'} 
                    iconName={IconLibrary.CHEVRON_RIGHT} 
                    className={`open-list-content-button`} 
                    onButtonClick={() => onOpenListClick(content.id, content.title)} 
                />
            ],
        }
    } else if (content.type === "page") {
        return {
            content: [
                <ListContentTile 
                    key={`${content.id}-content-title`}
                    listId={content?.parentIdAndTitles[0]?.id.toString()}
                    appGuid={appGuid}
                    item={content}
                    status={<FoundInPublishedStatus contentStatus={content.status} contentId={content.id} />}
                    archiveStatus={scheduledStatus(content.scheduledPublishDate, content.scheduledArchiveDate)}
                    isNotALink
                />, 
                <BasicRadioButton
                    key={content.id}
                    id={content.id}
                    text="Select"
                    isChecked={content.id === selectedContentId}
                    onClick={() => setSelectedContentId(content.id)}
                />,
            ],
        };
    } else {
        return undefined;
    }
}

export function getSearchContentRow(appGuid: string, content: ISearchContentItem, setSelectedContentId: (id: number) => void, selectedContentId?: number) {
    if (content.contentType !== "page") {
        return undefined;
    }

    const contentData = (
        <>
            <FoundInTile
                lists=  {content.foundIn.parentIdsAndTitles.map((parent) => ({
                            id: parent.id.toString(),
                            title: parent.title,
                        }))}
            />

            <ListContentTile
                key={`${content.id}-content-title`}
                listId={content.foundIn.parentIdsAndTitles[0]?.id.toString()}
                appGuid={appGuid}
                item={content}
                status={<FoundInPublishedStatus contentStatus={content.contentStatus} contentId={content.id} />}
                archiveStatus={foundInScheduledStatus(content.publishDate, content.archivedAt)}
                isNotALink
            />
        </>
    );

    const actionControl =
        (
            <BasicRadioButton
                className="search-result-margin"
                key={content.id}
                id={content.id}
                text="Select"
                isChecked={content.id === selectedContentId}
                onClick={() => setSelectedContentId(content.id)}
            />
        );

    return {
        content: [contentData, actionControl],
    };
}